<template>
  <div class="form-view loggedout-modal">
    <div class="modal-header">
        <h2 class="text-center">Logget ud</h2>
    </div>

    <div class="form">
        <p class="text-center">Du har været inaktiv for længe og er derfor automatisk blevet logget ud</p>
    </div>

    <div class="modal-footer">
        <div class="text-center modal-buttons">
            <button type="button" class="button-naked" @click="closeModal()">Luk</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'login-modal-loggedout',
    methods: {
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/login/login-modal-loggedout.vue